var _path, _path2, _path3, _path4, _path5, _path6;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaseStudy(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 13.3333H12.0003",
    stroke: "#57606A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.33331H11.3333C11.3333 9.7015 11.6318 9.99998 12 9.99998V9.33331ZM12 5.33331L12 4.66665C11.6318 4.66665 11.3333 4.96512 11.3333 5.33331L12 5.33331ZM12.6667 5.33331V4.66665V5.33331ZM12.6667 9.33331V9.99998V9.33331ZM12.6667 9.33331L12.6667 5.33331L11.3333 5.33331L11.3333 9.33331H12.6667ZM12 5.99998H12.6667L12.6667 4.66665H12L12 5.99998ZM12.6667 8.66665H12V9.99998H12.6667V8.66665ZM14 7.33331C14 8.06969 13.403 8.66665 12.6667 8.66665L12.6667 9.99998C14.1394 9.99998 15.3333 8.80607 15.3333 7.33331H14ZM12.6667 5.99998C13.403 5.99998 14 6.59693 14 7.33331H15.3333C15.3333 5.86055 14.1394 4.66665 12.6667 4.66665L12.6667 5.99998Z",
    fill: "#57606A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 5.33331V4.66665C2.2988 4.66665 2.00033 4.96512 2.00033 5.33331H2.66699ZM12.0003 5.33331H12.667C12.667 4.96512 12.3685 4.66665 12.0003 4.66665V5.33331ZM2.66699 5.99998H12.0003V4.66665H2.66699V5.99998ZM11.3337 5.33331V8.66665H12.667V5.33331H11.3337ZM3.33366 8.66665V5.33331H2.00033V8.66665H3.33366ZM7.33366 12.6666C5.12452 12.6666 3.33366 10.8758 3.33366 8.66665H2.00033C2.00033 11.6122 4.38814 14 7.33366 14V12.6666ZM11.3337 8.66665C11.3337 10.8758 9.5428 12.6666 7.33366 12.6666V14C10.2792 14 12.667 11.6122 12.667 8.66665H11.3337Z",
    fill: "#57606A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 2L9.33301 3.33333",
    stroke: "#57606A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 2L7.33301 3.33333",
    stroke: "#57606A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99967 2L5.33301 3.33333",
    stroke: "#57606A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseStudy);
export default __webpack_public_path__ + "static/media/Case Study.41511180b65949522f9dc77fc51a6bf0.svg";
export { ForwardRef as ReactComponent };